import { gql } from "@apollo/client";

export const linkTimesQuery = gql`
  query SchedulingLinkTimes($linkName: String!, $slug: String!, $body: ZonedDayTimeSlotRangeInput) {
    viewer {
      user {
        id
        emails
        linkNameErrorable {
          ... on LinkName {
            linkName
          }
          ... on GraphEntityError {
            message
            statusCode
            body
          }
        }
      }
      schedulingLinkDetails(linkName: $linkName, slug: $slug, body: $body) {
        __typename
        ... on GraphEntityError {
          message
          __typename
        }
        ... on SchedulingLinkDetails {
          linkName
          ownerProfile {
            givenName
            familyName
            externalImageUrl
          }
          publicMeetingSettings {
            id
            locationType
            name
            description
            durationMinutes
            highlightBestTimes
            endOfAvailability {
              dateOrDateTime
            }
          }
          suggestedSlotsByDate {
            date
            suggestedSlots {
              timeRange {
                startTime {
                  type
                  dateOrDateTime
                  timeZone
                  millis
                  offsetMinutes
                }
                endTime {
                  type
                  dateOrDateTime
                  timeZone
                  millis
                  offsetMinutes
                }
              }
              tag
            }
          }
        }
      }
    }
  }
`;

export const bookingQuery = gql`
  query SchedulingLinkBooking(
    $bookingId: String!
    $timeZone: String!
    $startDate: String!
    $endDate: String!
  ) {
    viewer {
      user {
        id
        linkNameErrorable {
          ... on LinkName {
            linkName
          }
          ... on GraphEntityError {
            message
            statusCode
            body
          }
        }
      }
      schedulingLinkBooking(bookingId: $bookingId) {
        __typename
        ... on GraphEntityError {
          statusCode
          message
          body
          __typename
        }
        ... on PublicBooking {
          startTime
          endTime
          ownerProfile {
            givenName
            familyName
            externalImageUrl
          }
          ownerEmail
          attendeeEmail
          locationType
          meetingName
          description
          schedulingLinkDetails(timeZone: $timeZone, startDate: $startDate, endDate: $endDate) {
            linkName
            slug
            publicMeetingSettings {
              id
            }
          }
        }
      }
    }
  }
`;

export const createBookingMutation = gql`
  mutation CreateBooking($input: CreateBookingMutationInput!) {
    createBooking(input: $input) {
      bookedDateOrDateTime
      bookedTimeZone
      __typename
    }
  }
`;

export const cancelBookingMutation = gql`
  mutation CancelBooking($bookingId: String!, $reason: String) {
    cancelBooking(input: { bookingId: $bookingId, reason: $reason }) {
      __typename
    }
  }
`;

export const findOrCreateLinkNameMutation = gql`
  mutation FindOrCreateLinkName($input: FindOrCreateLinkNameInput!) {
    findOrCreateLinkName(input: $input) {
      linkName
      schedulingLinks {
        linkName
        linkUrl
        meetingSettings {
          id
          timingSettings {
            durationMinutes
            timeRange {
              windowSizeDays
            }
          }
          name
          slug
          availabilityType
          isActive
        }
      }
    }
  }
`;
